import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { BackMatterNodeView } from "@/components/editor/nodeviews/BackMatterNodeView";

export const BackMatterBlock = Node.create({
  name: "backMatterBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      text: { default: "" },
      subType: { default: "glossary" },
      entries: { default: [] },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="back-matter-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "back-matter-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BackMatterNodeView);
  },
});
